import {
	BlogCategoriesByBrandDocument,
	BlogCategory,
	BlogSubCategoriesByBrandDocument,
	BlogSubCategory,
} from '@/graphql/__generated/sdk';

import { getGraphQLClientForContentful } from '@src/lib/graphql/client';
import { logWarning } from '@utils/miscUtils';

interface BlogCategoriesResponse {
	blogCategoryCollection: {
		items: BlogCategory[];
	};
}

interface BlogSubCategoriesResponse {
	blogSubCategoryCollection: {
		items: BlogSubCategory[];
	};
}

interface AllCategoriesByBrandResponse {
	categoriesResponse: BlogCategoriesResponse | null;
	subCategoriesResponse: BlogSubCategoriesResponse | null;
}

export const getAllBlogCategoryListByBrand = async (
	brandName: string,
	url: string,
	preview: boolean
): Promise<AllCategoriesByBrandResponse> => {
	const categoriesData: AllCategoriesByBrandResponse = {
		categoriesResponse: null,
		subCategoriesResponse: null,
	};
	try {
		if (!brandName) {
			return categoriesData;
		}

		const gqlClient = getGraphQLClientForContentful(url, preview);

		if (gqlClient === null) {
			logWarning('GQL_CLIENT_IS_NULL: missing token for fetching contentful data');
			throw new Error('gqlClient is null');
		}

		const requests = [
			gqlClient.query(BlogCategoriesByBrandDocument, {
				brandName,
				preview,
			}),
			gqlClient.query(BlogSubCategoriesByBrandDocument, {
				brandName,
				preview,
			}),
		];

		const [categoriesResponse, subCategoriesResponse] = await Promise.all(requests);

		if (categoriesResponse.data) {
			categoriesData.categoriesResponse = categoriesResponse.data as BlogCategoriesResponse;
		}

		if (subCategoriesResponse.data) {
			categoriesData.subCategoriesResponse = subCategoriesResponse.data as BlogSubCategoriesResponse;
		}

		return categoriesData;
	} catch (err) {
		const errorMessage = err instanceof Error ? err.message : String(err);
		logWarning(`Error fetching blog category list by brand: ${errorMessage}`);
		return categoriesData;
	}
};
